const getTestSiteStatus = (state: AnyFixMe) => state.testSiteStatus;

export { getTestSiteStatus };
